import { render, staticRenderFns } from "./ProfileDeleteCounter.vue?vue&type=template&id=56fdf85c&scoped=true"
import script from "./ProfileDeleteCounter.vue?vue&type=script&lang=js"
export * from "./ProfileDeleteCounter.vue?vue&type=script&lang=js"
import style0 from "./ProfileDeleteCounter.vue?vue&type=style&index=0&id=56fdf85c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fdf85c",
  null
  
)

export default component.exports